export default __webpack_public_path__ + "static/media/worksheet-not-submitted-icon.3c662b75.png";